import React, { useCallback, useEffect, useState } from 'react'
import { PriorityCellStyles } from './Style'
import { keyBy } from 'lodash'
import { priorityOptions } from 'keys/priority'
import { AutoComplete, Chip } from 'components/Form'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateTicketPriorityFetch } from 'store/middlewares/tickets.crud'
import { queryClient as qc } from 'keys'

const PriorityCell = (props) => {
    const { cell, row } = props
    let value = cell.getValue()
    const queryClient = useQueryClient()

    const [priority, setPriority] = useState()

    const priorityKeys = keyBy(priorityOptions, "id")
    const priorityItem = priorityKeys[value]

    const { mutateAsync: updateMessagePriority } = useMutation({
        mutationFn: updateTicketPriorityFetch,
        onSuccess: () => {
            queryClient.invalidateQueries([qc.ticket])
        }
    })

    const onChange = useCallback((value) => {
        setPriority(value)
        updateMessagePriority({ id: row.original.id, priority: value.id })
    }, [row])

    useEffect(() => {
        setPriority(priorityItem)
    }, [priorityItem])

    return (
        <PriorityCellStyles>
            <AutoComplete
                minWidth={priority?.width}
                badge={priority}
                options={priorityOptions}
                placeholder={""}
                input={{
                    onChange: onChange,
                    value: priority
                }}
                hideClear
            />
        </PriorityCellStyles>
    )
}

export default PriorityCell